import React, { useEffect, useState, useRef } from "react";
import { Card, Form, Input, Button, Select, Col, Row, message, Tooltip, Checkbox } from "antd";
import { UserOutlined, HomeOutlined, DeleteOutlined, UploadOutlined, SyncOutlined } from "@ant-design/icons";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import HTTPService from "../../../utils/makerequest";
import { Toast } from 'primereact/toast';
import { IAuthentication } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { useTranslation } from 'react-i18next';
import { IUser } from "../../../interfaces/IUser";
import i18n from "../../../i18n";
import moment from "moment";
import { API_URL } from "../../../utils/Constants";


const { Option } = Select;

const CompanyManagement: React.FunctionComponent<IPageProps> = props => {
  const { onSetPage } = props;
  const toast = useRef<any>(null);
  const [companyData, setCompanyData] = useState<ICompanyData>({});
  const [userData, setUserData] = useState<IUser[]>();
  const [logoFiles, setLogoFiles] = useState<any[]>([]);
  const { t } = useTranslation();


  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();

  const pageData: IPageData = {
    title: t('company_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    getCompanyData();
    getUserData();
  }, [i18n.language]);

  const cities = [
    'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Amasya', 'Ankara', 'Antalya',
    'Artvin', 'Aydın', 'Balıkesir', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu',
    'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır',
    'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun',
    'Gümüşhane', 'Hakkâri', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir',
    'Kars', 'Kastamonu', 'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli', 'Konya',
    'Kütahya', 'Malatya', 'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş',
    'Nevşehir', 'Niğde', 'Ordu', 'Rize', 'Sakarya', 'Samsun', 'Siirt', 'Sinop',
    'Sivas', 'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak',
    'Van', 'Yozgat', 'Zonguldak', 'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale',
    'Batman', 'Şırnak', 'Bartın', 'Ardahan', 'Iğdır', 'Yalova', 'Karabük',
    'Kilis', 'Osmaniye', 'Düzce'
  ];

  const getUserData = () => {
    HTTPService.GET(`/User/allUserName?companyId=${userInfo?.companyId}`)
      .then((res) => {
        if (!res.data) return;
        if (res.status === 200) {
          setUserData(res.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: res.error.message,
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };

  const getCompanyData = () => {
    HTTPService.GET(`/Company/byId?companyId=${userInfo?.companyId}`)
      .then((res) => {
        if (!res.data) return;
        if (res.status === 200) {
          setCompanyData(res.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: res.error.message,
            life: 3000
          });
        }
        let tmp: ICompanyData = res.data;
        setCompanyData(tmp);
      })
      .catch((error) => {
        console.error("Error fetching company data:", error);
      });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 102400) {
        message.error(t('file_too_100'));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoFiles([
          ...logoFiles,
          { filePath: reader.result }
        ]);
        message.success(t('logo_uploaded_successfully'));
      };
      reader.onerror = () => {
        message.error(t('logo_upload_failed'));
      };
      reader.readAsDataURL(file);
    }
  };


  const handleRemoveLogo = () => {
    setLogoFiles([]);
    setCompanyData({ ...companyData, companyImagePath: null });
  };

  const updateCompany = (values) => {
    const updatedCompanyData = {
      companyId: userInfo?.companyId,
      companyName: values.companyName,
      companyAddress: values.location,
      companyCity: values.city,
      responsibleUserId: values.responsibleUserId,
      companyImagePath: logoFiles[0]?.filePath?.split(',')[1] || companyData?.companyImagePath,
      companyCode: companyData?.companyCode || ''
    };

    HTTPService.PUT(`/Company/updateCompany`, updatedCompanyData)
      .then((res) => {
        if (res.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('update_success'),
            life: 3000
          });
        } else if (res.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(res.data),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('update_failure'),
            life: 3000
          });
        }
      })
      .catch(error => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('update_failure'),
          life: 3000
        });
      });
  };

  const updateSendMail = (values) => {
    const updatedMailData = {
      companyId: userInfo?.companyId,
      sendMailOnMaintenanceCreate: values.sendMailOnMaintenanceCreate,
      sendMailOnMaintenanceUpdate: values.sendMailOnMaintenanceUpdate,
      sendMailOnFaultCreate: values.sendMailOnFaultCreate,
      sendMailOnFaultUpdate: values.sendMailOnFaultUpdate,
      sendMailWeeklyMonday: values.sendMailWeeklyMonday 
    };

    HTTPService.PUT(`/Company/updatedCompanyMailData`, updatedMailData)
      .then((res) => {
        if (res.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('update_success'),
            life: 3000
          });
        } else if (res.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(res.data),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('update_failure'),
            life: 3000
          });
        }
      })
      .catch(error => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('update_failure'),
          life: 3000
        });
      });
  };



  const logoUrl = `${API_URL}/companyImages/${companyData.companyImagePath}`

  return (
    <>
      <Toast ref={toast} />
      <Card style={{ padding: '50px' }}>
        <Form
          layout="vertical"
          onFinish={updateCompany}
          fields={[
            {
              name: ['companyName'],
              value: companyData.companyName,
            },
            {
              name: ['location'],
              value: companyData.companyAddress,
            },
            {
              name: ['city'],
              value: companyData.companyCity,
            },
            {
              name: ['firstName'],
              value: companyData?.responsibleUserTBL?.firstName,
            },
            {
              name: ['responsibleUserId'],
              value: companyData?.responsibleUserId,
            },
            {
              name: ['companyCode'],
              value: companyData?.companyCode,
            },
            {
              name: ['companyImagePath'],
              value: logoUrl,
            }
          ]}
        >

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button
                  icon={<UploadOutlined />}
                  onClick={() => document.getElementById('file-input').click()}
                  style={{ padding: '10px 20px', borderRadius: '5px' }}
                  disabled={logoFiles.length > 0}
                >
                  {t('choose_logo')}
                </Button>

                <input
                  id="file-input"
                  type="file"
                  accept="image/*"
                  onChange={handleLogoChange}
                  style={{ display: 'none' }}
                />

                {logoFiles.length > 0 || companyData?.companyImagePath ? (
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                    <Tooltip title={t('logo_uploaded')}>
                      <img
                        src={logoFiles && logoFiles.length > 0 ? logoFiles[0].filePath : logoUrl}
                        style={{ width: '100px', marginRight: '10px', maxWidth: '100%', height: 'auto' }}
                      />
                    </Tooltip>

                    <Button
                      icon={<DeleteOutlined />}
                      onClick={handleRemoveLogo}
                      type="text"
                    />
                  </div>
                ) : null}

              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label={t('company_name')}
            name="companyName"
            rules={[{ required: true, message: t('please_input', { field: t('company_name') }) }]}
          >
            <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} placeholder="Company Name" />
          </Form.Item>


          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                label={t('address')}
                name="location"
                rules={[{ required: true, message: t('please_input', { field: t('address') }) }]}
              >
                <Input prefix={<HomeOutlined />} style={{ borderRadius: 0 }} placeholder={t('address')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('location_city')}
                name="city"
                rules={[{ required: true, message: t('please_select', { field: t('location_city') }) }]}
              >
                <Select
                  showSearch
                  placeholder={t('select_city')}
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    option?.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {cities.map((city) => (
                    <Option key={city} value={city}>
                      {city}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name='responsibleUserId'
            label={t('username')}
            rules={[
              {
                required: true,
                message: t('pleaseSelectResponsible'),
              },
            ]}
          >
            <Select
              showSearch placeholder={t('username')}
              style={{ marginBottom: '20px' }}
            >
              {userData?.map((user) => (
                <Select.Option key={user.userId} value={user.userId}>
                  {user.firstName} {user.lastName}
                </Select.Option>
              ))}
            </Select>

          </Form.Item>

          <Form.Item label={t('companyCode')} style={{ marginTop: '-20px' }}>
            <div style={{ borderRadius: 0, backgroundColor: '#ffffff', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
              {companyData?.companyCode || t('companyCode')}
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                height: 64,
                backgroundColor: 'transparent',
                color: '#1890ff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
                border: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
            >
              <SyncOutlined style={{ fontSize: 20 }} />
              <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                {t('update_information')}
              </span>
            </Button>
          </Form.Item>
        </Form>
      </Card>

      {/* <Row gutter={16}>
  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
    <Card
      style={{
        textAlign: 'center',
        height: '150px',
        borderRadius: '10px',
        padding: '20px',
        display: 'flex',         // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center',    // Dikeyde ortalama
      }}
    >
      <Button type="primary" style={{ borderRadius: '5px' }}
       onClick={() => {
        window.location.replace(`/admin/add-licence/${userInfo.companyId}/${2}`);
      }}>
       {t('addLicence')}
      </Button>
    </Card>
  </Col>
  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
    <Card
      style={{
        textAlign: 'center',
        height: '150px',
        borderRadius: '10px',
        padding: '20px',
        display: 'flex',         // Flexbox kullanımı
        justifyContent: 'center', // Yatayda ortalama
        alignItems: 'center',    // Dikeyde ortalama
      }}
    >
      <Button type="primary" style={{ borderRadius: '5px' }}
       onClick={() => {
        window.location.replace(`/admin/transfer-licence/${companyData.licenceKey}/${userInfo.companyId}/${2}`);
      }}
      disabled={!companyData.licenceKey}
      >
       {t('transferLicence')}
      </Button>
    </Card>
  </Col>
</Row> */}



      <Card style={{ padding: '50px' }}>
        <div style={{ textAlign: 'left', fontSize: '16px', fontWeight: 'bold', marginBottom: '20px' }}>
          {t('packageInfo')}
        </div>
        <Form
          layout="vertical"
          onFinish={updateCompany}
          fields={[
            {
              name: ['packageName'],
              value: companyData?.licencePackagesTBL?.packageName,
            },
            {
              name: ['licenceStartDate'],
              value: moment(companyData?.licenceStartDate),
            },
            {
              name: ['licenceEndDate'],
              value: moment(companyData.licencePackagesTBL?.licenseExpiryDate),
            }
          ]}
        >

          <Form.Item label={t('licenceName')}>
            <div style={{ borderRadius: 0, backgroundColor: '#ffffff', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
              {companyData?.licencePackagesTBL?.packageName || t('licenceName')}
            </div>
          </Form.Item>


          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={t('Licence Start Date')}>
                <div style={{ borderRadius: 0, backgroundColor: '#ffffff', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
                  {companyData?.licenceStartDate ? moment(companyData?.licenceStartDate).format("DD.MM.YYYY HH:mm") : t('Licence Start Date')}
                </div>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t('Licence Finish Date')}>
                <div style={{ borderRadius: 0, backgroundColor: '#ffffff', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
                  {companyData?.licencePackagesTBL?.licenseExpiryDate ? moment(companyData?.licencePackagesTBL?.licenseExpiryDate).format("DD.MM.YYYY HH:mm") : t('Licence Finish Date')}
                </div>
              </Form.Item>
            </Col>
          </Row>

        </Form>

      </Card>

      <Card style={{ padding: '50px', marginTop: '24px' }}>
  <div style={{ textAlign: 'left', fontSize: '16px', fontWeight: 'bold', marginBottom: '20px' }}>
    {t('mail_notification_settings')}
  </div>
  <Form
          layout="vertical"
          onFinish={updateSendMail}
          fields={[
            {
              name: ['sendMailOnMaintenanceCreate'],
              value: companyData.sendMailOnMaintenanceCreate,
            },
            {
              name: ['sendMailOnMaintenanceUpdate'],
              value: companyData.sendMailOnMaintenanceUpdate,
            },
            {
              name: ['sendMailOnFaultCreate'],
              value: companyData.sendMailOnFaultCreate,
            },
            {
              name: ['sendMailOnFaultUpdate'],
              value: companyData?.sendMailOnFaultUpdate,
            },
            {
              name: ['sendMailWeeklyMonday'],
              value: companyData?.sendMailWeeklyMonday,
            }
          ]}
        >
    <Form.Item name="sendMailOnMaintenanceCreate" valuePropName="checked">
      <Checkbox>
        {t('mail_on_maintenance_create')}
      </Checkbox>
    </Form.Item>
    <Form.Item name="sendMailOnMaintenanceUpdate" valuePropName="checked">
      <Checkbox>
        {t('mail_on_maintenance_update')}
      </Checkbox>
    </Form.Item>
    <Form.Item name="sendMailOnFaultCreate" valuePropName="checked">
      <Checkbox>
        {t('mail_on_fault_create')}
      </Checkbox>
    </Form.Item>
    <Form.Item name="sendMailOnFaultUpdate" valuePropName="checked">
      <Checkbox>
         {t('mail_on_fault_update')}
      </Checkbox>
    </Form.Item>
    <Form.Item name="sendMailWeeklyMonday" valuePropName="checked">
      <Checkbox>
        {t('mail_on_weekly_monday')}
      </Checkbox>
    </Form.Item>
    <Form.Item>
      <Button type="primary" htmlType="submit">
        {t('update_information')}
      </Button>
    </Form.Item>
  </Form>
</Card>
    </>

  );
};

export default CompanyManagement;
